module.exports = __webpack_public_path__ + "media/images/lp_cv-half_price-fe29f48c641b4d0e3bf59890c6f46fed.webp";